import { useEffect } from 'react';
import useAnalyticsCalls from '@/hooks/use-analytics';

/**
 * Shown when Stripe.js fails to load after all retries are exhausted.
 * Most commonly caused by iOS content blockers preventing js.stripe.com.
 */
export function StripeLoadError() {
  const { callPaymentStripeLoadFailed } = useAnalyticsCalls();

  useEffect(() => {
    callPaymentStripeLoadFailed();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 rounded-2xl border border-white/10 bg-catch-dark-blue-90/90 p-8 text-center shadow-xl backdrop-blur-sm">

        {/* Catch logo */}
        <img src="/images/logo-catch-icon-white.svg" alt="Catch" className="h-8 w-8 opacity-60" />

        {/* Warning icon */}
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-catch-yellow/15">
          <svg
            className="h-7 w-7 text-catch-yellow"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>

        {/* Copy */}
        <div className="flex flex-col gap-2">
          <h2 className="text-xl font-bold text-white">Payment couldn&apos;t load</h2>
          <p className="text-sm leading-relaxed text-white/70">
            This is usually caused by an ad or content blocker. Try one of the following:
          </p>
          <ul className="mt-1 space-y-1 text-left text-sm text-white/60">
            <li className="flex items-start gap-2">
              <span className="mt-0.5 text-catch-avocado-400">→</span>
              Disable your content blocker and reload
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5 text-catch-avocado-400">→</span>
              Open this page in a private or incognito window
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex w-full flex-col gap-3">
          <button
            className="flex h-11 w-full items-center justify-center rounded-full px-6 text-sm font-bold transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#7cf1c7', color: '#183344' }}
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
          <button
            className="flex h-11 w-full items-center justify-center rounded-full border px-6 text-sm font-medium transition-colors hover:bg-white/10"
            style={{ borderColor: 'rgba(255,255,255,0.3)', color: '#fff', backgroundColor: 'transparent' }}
            onClick={() => window.Intercom?.('show')}
          >
            Contact support
          </button>
        </div>

        {/* Trust signal */}
        <p className="text-xs text-white/40">
          Your information is secure. No payment details were submitted.
        </p>

      </div>
    </div>
  );
}
